export default "__VITE_ASSET__BElNphGV__"